import React, { FC } from "react";
import { StyledBookingFlowButton } from
  "../../shared/containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { ISquareInvoices } from "../../services/delinquent-payment/delinquent-payment.interface";
import { fromISOToOverdueDateFormat } from "../../utils/unix-timestamp";
import { userActivityLogger } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";

  interface IPetInvoiceCard{
    invoiceData: ISquareInvoices;
    petName: string;
  }

const PetInvoiceCard: FC<IPetInvoiceCard> = ({ invoiceData, petName }) => {
  const handlePayNowCtaClick = () => {
    userActivityLogger(MIXPANEL_EVENTS.PAY_NOW_CLICKED,
      {
        pet_name: petName,
        referred_from_page: "plan_and_billing",
        due_amount: `$${invoiceData.amount}`,
        invoice_due_date: invoiceData.dueDate,
      });
    window.open(invoiceData.publicUrl);
  };

  return (
    <div className="p-3 flex gap-2 items-center justify-between border border-gray-4 rounded-xl">
      <div className="flex flex-col gap-1">
        <div className="text-xs text-gray-1 font-semibold">
          {fromISOToOverdueDateFormat(invoiceData.dueDate)}
        </div>
        <div className="text-sm text-red-2 font-semibold">
            Overdue Invoice
        </div>
      </div>
      <StyledBookingFlowButton
        disabled={false}
        fullWidth
        color="primary"
        size="small"
        onClick={()=>handlePayNowCtaClick()}
        className="!w-28 !h-8"
      >
          Pay Now
      </StyledBookingFlowButton>
    </div>
  );
};

export default PetInvoiceCard;
